export const categories = [
  {
    id: "91-today",
    name: "91今日吃瓜",
    slug: "91-today",
    description: "最新最全的91今日吃瓜热点汇总，实时追踪每日热门八卦事件",
    icon: "ri-camera-lens-line",
    color: "bg-rose-100 text-rose-700",
    count: 1286,
  },
  {
    id: "51-domestic",
    name: "51国产吃瓜",
    slug: "51-domestic",
    description: "国产吃瓜在线专区，聚焦国内娱乐圈与网红圈最新动态",
    icon: "ri-fire-line",
    color: "bg-amber-100 text-amber-700",
    count: 963,
  },
  {
    id: "black-material",
    name: "黑料爆料",
    slug: "black-material",
    description: "独家黑料深度爆料，还原事件真相的一手信息聚合平台",
    icon: "ri-spy-line",
    color: "bg-zinc-100 text-zinc-700",
    count: 2104,
  },
  {
    id: "daily-must",
    name: "每日必吃",
    slug: "daily-must",
    description: "每日精选必吃瓜内容，不错过任何一条重磅八卦消息",
    icon: "ri-star-line",
    color: "bg-orange-100 text-orange-700",
    count: 1587,
  },
  {
    id: "collection",
    name: "吃瓜合集",
    slug: "collection",
    description: "热门吃瓜事件合集整理，系列追踪报道与完整时间线回顾",
    icon: "ri-folder-line",
    color: "bg-emerald-100 text-emerald-700",
    count: 742,
  },
];

export const articles = [
  {
    id: 1,
    title: "顶流男星深夜密会神秘女子，酒店共度8小时全程被拍",
    slug: "top-star-secret-date",
    category: "91-today",
    excerpt: "据知情人士透露，该男星与神秘女子在某五星级酒店密会长达8小时，期间有工作人员多次送餐进入。狗仔蹲守一整夜拍到二人先后离开的画面，全程实锤。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dimly%20lit%20luxurious%20hotel%20corridor%20at%20night%20with%20soft%20warm%20lighting%20from%20wall%20sconces%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field%2C%20rich%20dark%20tones%20with%20touches%20of%20gold%2C%20editorial%20photography%20style%2C%20elegant%20and%20suspenseful%20mood&width=800&height=500&seq=article-img-01&orientation=landscape",
    imageQuery: "A dimly lit luxurious hotel corridor at night with soft warm lighting from wall sconces, mysterious atmosphere, cinematic composition, shallow depth of field, rich dark tones with touches of gold, editorial photography style, elegant and suspenseful mood",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-06",
    views: 285000,
    comments: 3842,
    tags: ["顶流", "密会", "实锤", "酒店"],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 2,
    title: "知名女网红偷税被查，补缴罚款超千万，账号已被封禁",
    slug: "influencer-tax-evasion",
    category: "black-material",
    excerpt: "某拥有3000万粉丝的头部女网红因涉嫌偷逃税款被税务机关立案调查，初步核实需补缴税款及罚款合计超过1200万元，其全平台账号已被暂时封禁。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20modern%20office%20desk%20with%20scattered%20financial%20documents%2C%20calculator%20and%20glowing%20laptop%20screen%20in%20dramatic%20lighting%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20amber%20and%20dark%20tones%2C%20investigative%20journalism%20aesthetic%2C%20high%20contrast%20composition&width=800&height=500&seq=article-img-02&orientation=landscape",
    imageQuery: "A modern office desk with scattered financial documents, calculator and glowing laptop screen in dramatic lighting, moody atmosphere with deep shadows, cinematic noir style, warm amber and dark tones, investigative journalism aesthetic, high contrast composition",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-05",
    views: 412000,
    comments: 5621,
    tags: ["网红", "偷税", "封禁", "千万罚款"],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 3,
    title: "热门综艺录制现场爆发冲突，两位导师当场互怼场面失控",
    slug: "variety-show-conflict",
    category: "51-domestic",
    excerpt: "某热门音乐选秀综艺录制现场突发意外状况，两位导师因选手晋级问题产生严重分歧，在录制现场爆发激烈争吵，节目组紧急叫停录制。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20television%20studio%20set%20with%20bright%20stage%20lights%20casting%20long%20shadows%2C%20empty%20chairs%20on%20stage%2C%20tense%20atmosphere%2C%20behind-the-scenes%20perspective%2C%20cinematic%20lighting%20with%20strong%20contrast%2C%20warm%20spotlight%20and%20cool%20ambient%20mix%2C%20documentary%20photography%20style&width=800&height=500&seq=article-img-03&orientation=landscape",
    imageQuery: "A dramatic television studio set with bright stage lights casting long shadows, empty chairs on stage, tense atmosphere, behind-the-scenes perspective, cinematic lighting with strong contrast, warm spotlight and cool ambient mix, documentary photography style",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-06",
    views: 198000,
    comments: 2891,
    tags: ["综艺", "冲突", "导师", "录制事故"],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 4,
    title: "某知名企业家被曝婚内出轨，小三竟是旗下公司女高管",
    slug: "businessman-affair",
    category: "black-material",
    excerpt: "身价数十亿的某知名科技公司创始人被曝婚内出轨，出轨对象被指是其旗下某子公司的女性高管，两人被拍到多次同游海外。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20luxurious%20tropical%20beach%20resort%20with%20infinity%20pool%20overlooking%20the%20ocean%20at%20sunset%2C%20elegant%20and%20romantic%20atmosphere%2C%20warm%20golden%20hour%20light%2C%20soft%20focus%20background%2C%20sophisticated%20travel%20lifestyle%20photography%2C%20serene%20and%20exclusive%20mood&width=800&height=500&seq=article-img-04&orientation=landscape",
    imageQuery: "A luxurious tropical beach resort with infinity pool overlooking the ocean at sunset, elegant and romantic atmosphere, warm golden hour light, soft focus background, sophisticated travel lifestyle photography, serene and exclusive mood",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-04",
    views: 356000,
    comments: 4821,
    tags: ["企业家", "出轨", "婚内", "女高管"],
    isHot: false,
    isFeatured: true,
  },
  {
    id: 5,
    title: "某男星前女友发文实锤：交往期间劈腿三人，附聊天记录",
    slug: "actor-cheating-exposed",
    category: "daily-must",
    excerpt: "某当红男星的前女友深夜发长文，控诉其在恋爱期间同时与三名女性保持关系，并附上多张聊天记录截图作为证据，引发全网震荡。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20chat%20messages%20on%20screen%20lying%20on%20a%20dark%20wooden%20surface%2C%20soft%20warm%20desk%20lamp%20light%20from%20above%2C%20dramatic%20shadows%2C%20intimate%20and%20moody%20atmosphere%2C%20night%20time%20setting%2C%20modern%20lifestyle%20photography%20with%20emotional%20tension&width=800&height=500&seq=article-img-05&orientation=landscape",
    imageQuery: "A smartphone displaying chat messages on screen lying on a dark wooden surface, soft warm desk lamp light from above, dramatic shadows, intimate and moody atmosphere, night time setting, modern lifestyle photography with emotional tension",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-06",
    views: 523000,
    comments: 7842,
    tags: ["男星", "劈腿", "聊天记录", "塌房"],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 6,
    title: "某选秀冠军被曝学历造假，真实学历仅为初中毕业",
    slug: "talent-show-fake-degree",
    category: "51-domestic",
    excerpt: "去年某大型选秀节目的总冠军被网友扒出学历造假，其一直宣称的某知名音乐学院本科文凭被证实为伪造，真实教育经历令人大跌眼镜。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20graduation%20certificate%20and%20diploma%20with%20blurred%20academic%20robe%20in%20background%2C%20dramatic%20single%20light%20source%20from%20above%2C%20mysterious%20and%20investigative%20mood%2C%20deep%20shadows%2C%20warm%20amber%20tones%20mixed%20with%20darkness%2C%20documentary%20evidence%20photography%20style&width=800&height=500&seq=article-img-06&orientation=landscape",
    imageQuery: "A graduation certificate and diploma with blurred academic robe in background, dramatic single light source from above, mysterious and investigative mood, deep shadows, warm amber tones mixed with darkness, documentary evidence photography style",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-03",
    views: 187000,
    comments: 2531,
    tags: ["选秀", "学历造假", "冠军", "人设崩塌"],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 7,
    title: "娱乐圈又一对金童玉女被曝离婚，财产分割涉及数亿",
    slug: "celebrity-divorce",
    category: "daily-must",
    excerpt: "被誉为娱乐圈模范夫妻的一对明星夫妇被曝已在办理离婚手续，双方名下涉及数亿共同财产的分割问题成为焦点，知情人透露离婚原因令人唏嘘。",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20wedding%20rings%20placed%20apart%20on%20a%20dark%20textured%20surface%20with%20dramatic%20side%20lighting%2C%20melancholy%20and%20elegant%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20warm%20and%20cool%20tones%20mixing%2C%20emotional%20cinematic%20composition%2C%20sophisticated%20still%20life%20photography&width=800&height=500&seq=article-img-07&orientation=landscape",
    imageQuery: "Two wedding rings placed apart on a dark textured surface with dramatic side lighting, melancholy and elegant atmosphere, shallow depth of field, warm and cool tones mixing, emotional cinematic composition, sophisticated still life photography",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-06",
    views: 342000,
    comments: 5120,
    tags: ["离婚", "明星", "财产分割", "模范夫妻"],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 8,
    title: "吃瓜合集：2026年上半年十大塌房事件完整回顾",
    slug: "2026-half-year-review",
    category: "collection",
    excerpt: "盘点2026年上半年最令人震惊的十大明星网红塌房事件，从偷税漏税到劈腿出轨，从学历造假到违法被抓，每一个都让人三观震碎。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20dramatic%20collage%20composition%20of%20newspaper%20headlines%20and%20magazine%20covers%20scattered%20on%20a%20dark%20desk%2C%20warm%20cinematic%20lighting%20with%20deep%20shadows%2C%20editorial%20journalism%20aesthetic%2C%20vintage%20newsroom%20atmosphere%2C%20rich%20contrast%2C%20sophisticated%20documentary%20style&width=800&height=500&seq=article-img-08&orientation=landscape",
    imageQuery: "A dramatic collage composition of newspaper headlines and magazine covers scattered on a dark desk, warm cinematic lighting with deep shadows, editorial journalism aesthetic, vintage newsroom atmosphere, rich contrast, sophisticated documentary style",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-01",
    views: 289000,
    comments: 4203,
    tags: ["合集", "塌房", "2026", "年度回顾"],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 9,
    title: "某直播平台一姐突然宣布退网，原因竟是遭同行威胁",
    slug: "streamer-quit-threat",
    category: "black-material",
    excerpt: "坐拥2000万粉丝的某直播平台一姐突然在直播间泪洒当场并宣布永久退网，事后有知情人爆料其长期遭受同行恶意竞争和人身威胁。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20streaming%20setup%20with%20ring%20light%2C%20microphone%20and%20empty%20chair%20in%20a%20dimly%20lit%20room%2C%20melancholic%20atmosphere%2C%20soft%20blue%20and%20warm%20amber%20mixed%20lighting%2C%20intimate%20and%20emotional%20mood%2C%20behind-the-scenes%20documentary%20photography%20style%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=article-img-09&orientation=landscape",
    imageQuery: "A streaming setup with ring light, microphone and empty chair in a dimly lit room, melancholic atmosphere, soft blue and warm amber mixed lighting, intimate and emotional mood, behind-the-scenes documentary photography style, shallow depth of field",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-05",
    views: 234000,
    comments: 3621,
    tags: ["直播", "退网", "威胁", "恶性竞争"],
    isHot: true,
    isFeatured: false,
  },
  {
    id: 10,
    title: "某知名导演被多名女演员联合举报性骚扰，警方已介入",
    slug: "director-harassment-allegations",
    category: "daily-must",
    excerpt: "五位曾在某知名导演作品中出演角色的女演员联合发布公开信，指控该导演在片场及私下场合多次实施性骚扰行为，目前警方已正式立案调查。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20stark%20photograph%20of%20a%20spotlight%20on%20an%20empty%20film%20set%2C%20dramatic%20contrast%20between%20light%20and%20shadow%2C%20powerful%20and%20somber%20atmosphere%2C%20cinematic%20composition%2C%20black%20background%20with%20single%20beam%20of%20warm%20light%2C%20metaphorical%20and%20striking%20editorial%20photography&width=800&height=500&seq=article-img-10&orientation=landscape",
    imageQuery: "A stark photograph of a spotlight on an empty film set, dramatic contrast between light and shadow, powerful and somber atmosphere, cinematic composition, black background with single beam of warm light, metaphorical and striking editorial photography",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-07",
    views: 489000,
    comments: 6321,
    tags: ["导演", "性骚扰", "举报", "警方介入"],
    isHot: true,
    isFeatured: true,
  },
  {
    id: 11,
    title: "情侣网红分手互撕，男方曝光女方出轨聊天记录",
    slug: "couple-influencer-breakup",
    category: "51-domestic",
    excerpt: "拥有500万粉丝的情侣网红账号突然停更，随后双方分别在社交媒体上发长文互撕。男方率先曝光女方与其他男性的暧昧聊天记录。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20broken%20heart%20shaped%20neon%20sign%20on%20a%20dark%20brick%20wall%2C%20urban%20night%20atmosphere%2C%20moody%20and%20dramatic%20lighting%2C%20pink%20and%20blue%20neon%20glow%2C%20melancholic%20and%20emotional%20street%20photography%20style%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field&width=800&height=500&seq=article-img-11&orientation=landscape",
    imageQuery: "A broken heart shaped neon sign on a dark brick wall, urban night atmosphere, moody and dramatic lighting, pink and blue neon glow, melancholic and emotional street photography style, cinematic composition with shallow depth of field",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-04",
    views: 167000,
    comments: 2341,
    tags: ["网红", "情侣", "分手", "互撕"],
    isHot: false,
    isFeatured: false,
  },
  {
    id: 12,
    title: "吃瓜合集：某顶流歌手完整塌房时间线整理",
    slug: "singer-downfall-timeline",
    category: "collection",
    excerpt: "从出道巅峰到全面塌房，某顶流歌手在短短三个月内经历了怎样的戏剧性反转？本文为您完整梳理事件全貌与时间线。",
    imageUrl: "https://readdy.ai/api/search-image?query=A%20descending%20staircase%20in%20dramatic%20lighting%20with%20broken%20vinyl%20records%20and%20sheet%20music%20scattered%20on%20steps%2C%20metaphorical%20and%20artistic%20composition%2C%20warm%20dramatic%20light%20from%20above%2C%20shadows%20and%20light%20interplay%2C%20conceptual%20editorial%20photography%2C%20emotional%20and%20powerful%20visual%20narrative&width=800&height=500&seq=article-img-12&orientation=landscape",
    imageQuery: "A descending staircase in dramatic lighting with broken vinyl records and sheet music scattered on steps, metaphorical and artistic composition, warm dramatic light from above, shadows and light interplay, conceptual editorial photography, emotional and powerful visual narrative",
    imageWidth: 800,
    imageHeight: 500,
    date: "2026-07-02",
    views: 178000,
    comments: 2671,
    tags: ["合集", "歌手", "塌房", "时间线"],
    isHot: false,
    isFeatured: false,
  },
];

export const comments = [
  {
    id: 1,
    articleId: 1,
    userName: "吃瓜不嫌事大",
    avatar: "https://readdy.ai/api/search-image?query=A%20cartoon%20style%20watermelon%20character%20avatar%20with%20sunglasses%2C%20playful%20and%20cool%2C%20simple%20flat%20illustration%20on%20white%20background%2C%20minimalist%20design&width=80&height=80&seq=avatar-01&orientation=squarish",
    content: "这次是真实锤了，粉丝还能怎么洗？照片都拍这么清楚了。",
    likes: 3245,
    date: "2026-07-06",
  },
  {
    id: 2,
    articleId: 1,
    userName: "八卦研究员",
    avatar: "https://readdy.ai/api/search-image?query=A%20detective%20magnifying%20glass%20cartoon%20avatar%2C%20bright%20colors%2C%20simple%20flat%20illustration%20on%20white%20background%2C%20minimalist%20design&width=80&height=80&seq=avatar-02&orientation=squarish",
    content: "这已经是今年第三次了吧？前两次说是工作关系，这次8个小时的工作关系？笑死",
    likes: 2189,
    date: "2026-07-06",
  },
  {
    id: 3,
    articleId: 1,
    userName: "路过看看",
    avatar: "https://readdy.ai/api/search-image?query=A%20popcorn%20bucket%20cartoon%20avatar%2C%20fun%20and%20casual%2C%20simple%20flat%20illustration%20on%20white%20background%2C%20minimalist%20design&width=80&height=80&seq=avatar-03&orientation=squarish",
    content: "我就想知道这女的是谁，有扒出来的吗？",
    likes: 892,
    date: "2026-07-06",
  },
  {
    id: 4,
    articleId: 2,
    userName: "税务小达人",
    avatar: "https://readdy.ai/api/search-image?query=A%20calculator%20icon%20cartoon%20avatar%2C%20clean%20and%20professional%2C%20simple%20flat%20illustration%20on%20white%20background%2C%20minimalist%20design&width=80&height=80&seq=avatar-04&orientation=squarish",
    content: "赚那么多还逃税，1200万对她们来说也就是几个广告的事吧",
    likes: 4521,
    date: "2026-07-05",
  },
  {
    id: 5,
    articleId: 2,
    userName: "理性吃瓜群众",
    avatar: "https://readdy.ai/api/search-image?query=A%20pair%20of%20glasses%20cartoon%20avatar%2C%20smart%20and%20neutral%2C%20simple%20flat%20illustration%20on%20white%20background%2C%20minimalist%20design&width=80&height=80&seq=avatar-05&orientation=squarish",
    content: "这两年倒下的网红真是一个接一个，流量变现太快了，都飘了",
    likes: 3120,
    date: "2026-07-05",
  },
];

export const hotTopics = [
  { id: 1, tag: "顶流深夜密会", count: "5.2亿阅读" },
  { id: 2, tag: "网红偷税被封", count: "4.8亿阅读" },
  { id: 3, tag: "综艺导师互怼", count: "3.1亿阅读" },
  { id: 4, tag: "企业家出轨门", count: "4.5亿阅读" },
  { id: 5, tag: "男星劈腿实锤", count: "6.7亿阅读" },
  { id: 6, tag: "女网红退网威胁", count: "2.9亿阅读" },
  { id: 7, tag: "导演性骚扰举报", count: "5.8亿阅读" },
  { id: 8, tag: "明星离婚财产分割", count: "4.2亿阅读" },
];

export const testimonials = [
  {
    id: 1,
    userName: "资深吃瓜人",
    role: "8年吃瓜老粉",
    avatar: "https://readdy.ai/api/search-image?query=A%20cute%20watermelon%20slice%20character%20avatar%20with%20sparkling%20eyes%2C%20kawaii%20style%2C%20simple%20flat%20illustration%20on%20white%20background&width=80&height=80&seq=test-av-01&orientation=squarish",
    content: "关注今日吃瓜三年了，更新速度是真的快！每次有大事件发生，这里总是第一时间出详细报道，比那些主流媒体快多了。而且内容非常全面，不会断章取义。",
  },
  {
    id: 2,
    userName: "娱乐圈观察员",
    role: "自媒体博主",
    avatar: "https://readdy.ai/api/search-image?query=A%20camera%20lens%20character%20avatar%2C%20creative%20and%20artsy%2C%20simple%20flat%20illustration%20on%20white%20background&width=80&height=80&seq=test-av-02&orientation=squarish",
    content: "作为同行，我不得不说今日吃瓜的选题眼光真的很毒辣。他们总能挖到别人挖不到的料，而且整理得清清楚楚。我经常来这儿找选题灵感，强烈推荐！",
  },
  {
    id: 3,
    userName: "上班摸鱼专业户",
    role: "忠实粉丝",
    avatar: "https://readdy.ai/api/search-image?query=A%20coffee%20cup%20character%20avatar%2C%20relaxed%20and%20casual%20vibes%2C%20simple%20flat%20illustration%20on%20white%20background&width=80&height=80&seq=test-av-03&orientation=squarish",
    content: "每天上班第一件事就是打开今日吃瓜看看有没有新瓜。同事还以为我在认真工作，其实我是在偷偷吃瓜哈哈！信息量超大，吃一个瓜能管一上午。",
  },
  {
    id: 4,
    userName: "八卦街居委会",
    role: "社区活跃用户",
    avatar: "https://readdy.ai/api/search-image?query=A%20chat%20bubble%20character%20avatar%20with%20heart%2C%20friendly%20and%20warm%2C%20simple%20flat%20illustration%20on%20white%20background&width=80&height=80&seq=test-av-04&orientation=squarish",
    content: "评论区氛围太好了！大家理性吃瓜不撕逼，管理员也及时清理引战言论。不像某些平台评论区全是水军和喷子。在这里看评论有时候比看正文还有意思。",
  },
  {
    id: 5,
    userName: "热点追踪侠",
    role: "金牌会员",
    avatar: "https://readdy.ai/api/search-image?query=A%20lightning%20bolt%20character%20avatar%2C%20energetic%20and%20dynamic%2C%20simple%20flat%20illustration%20on%20white%20background&width=80&height=80&seq=test-av-05&orientation=squarish",
    content: "我从51国产吃瓜那边追过来的，发现这边的更新更及时。特别是黑料爆料板块，很多料都是这里的独家首发。已经安利给身边所有爱吃瓜的朋友了！",
  },
];

export const siteInfo = {
  name: "今日吃瓜",
  fullName: "今日吃瓜 | 全网黑料爆料聚合平台",
  description: "今日吃瓜🔔品牌入口，覆盖91今日吃瓜、合集、51国产吃瓜在线等核心搜索词，💎每日更新黑料爆料与热门吃瓜事件，为吃瓜爱好者提供一站式内容承接与实时追踪。",
  keywords: "91今日吃瓜,今日吃瓜合集,51国产吃瓜在线,今日吃瓜黑料,今日吃瓜爆料,今日吃瓜事件,今日吃瓜每日必吃,今日吃瓜入口,今日吃瓜在线,今日吃瓜官网",
  url: "https://www.jinrichigua.com",
  established: "2020年3月",
  totalArticles: 12580,
  dailyVisitors: "50万+",
  coverageEvents: "5000+",
  contactEmail: "hello@jinrichigua.com",
  contactWechat: "jinrichigua2020",
};